/* MyButchery theme: vanilla JS, no build step needed */

document.addEventListener('DOMContentLoaded', function () {
  initAnnouncementBar();
  initHeader();
  initCartDrawer();
  initEmailPopup();
  initFaqAccordions();
  initProductRails();
  initProductGallery();
  initSwipeGallery();
  initStickyAddToCart();
  initFilterPanels();
  initEmailSignup();
  initScrollReveal();
});

/* ---------- Inline email signup section ---------- */
function initEmailSignup() {
  document.querySelectorAll('[data-signup-submit]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var wrap = form.closest('[data-email-signup]');
      wrap.querySelector('[data-signup-form]').hidden = true;
      wrap.querySelector('[data-signup-success]').hidden = false;
    });
  });
}

/* ---------- Announcement bar rotator ---------- */
function initAnnouncementBar() {
  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('[data-announcement-msg]');
    if (msgs.length < 2) return;
    var index = 0;
    setInterval(function () {
      var prevIndex = index;
      index = (index + 1) % msgs.length;
      msgs.forEach(function (m, i) {
        m.classList.remove('is-active', 'is-prev');
        if (i === index) m.classList.add('is-active');
        else if (i === prevIndex) m.classList.add('is-prev');
      });
    }, 3500);
  });
}

/* ---------- Header: mobile menu + search toggle ---------- */
function initHeader() {
  var burger = document.querySelector('[data-header-burger]');
  var mobileNav = document.querySelector('[data-header-mobile-nav]');
  var searchToggle = document.querySelector('[data-header-search-toggle]');
  var searchPanel = document.querySelector('[data-header-search-panel]');

  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      burger.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', mobileNav.classList.contains('is-open') ? 'true' : 'false');
    });
  }
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('is-open');
      if (searchPanel.classList.contains('is-open')) {
        var input = searchPanel.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  /* Highlight the active tab in the mobile bottom nav */
  var path = window.location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('[data-tabbar-link]').forEach(function (link) {
    var linkPath = (link.getAttribute('data-tabbar-path') || '').replace(/\/$/, '') || '/';
    if (linkPath === path) link.classList.add('is-active');
  });
}

/* ---------- Cart drawer (uses Shopify AJAX Cart API) ---------- */
function initCartDrawer() {
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function bumpCartIcons() {
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.classList.remove('is-bumped');
      /* force reflow so the animation can retrigger on rapid adds */
      void btn.offsetWidth;
      btn.classList.add('is-bumped');
      setTimeout(function () { btn.classList.remove('is-bumped'); }, 550);
    });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  window.MyButcheryCart = {
    open: openDrawer,
    close: closeDrawer,
    add: addToCart,
    refresh: refreshDrawer,
  };

  drawer.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-key');
      var delta = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      var line = qtyBtn.closest('[data-line-qty]');
      var current = parseInt(line.getAttribute('data-line-qty'), 10);
      updateLine(key, Math.max(0, current + delta));
    }
    var removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      updateLine(removeBtn.getAttribute('data-key'), 0);
    }
  });

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        bumpCartIcons();
        return refreshDrawer().then(openDrawer);
      });
  }

  function updateLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function refreshDrawer() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function renderCart(cart) {
    var countEls = document.querySelectorAll('[data-cart-count], [data-cart-count-badge]');
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    var body = drawer.querySelector('[data-cart-body]');
    var footer = drawer.querySelector('[data-cart-footer]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = drawer.querySelector('[data-cart-empty-template]').innerHTML;
      if (footer) footer.hidden = true;
      return;
    }
    if (footer) footer.hidden = false;

    var html = cart.items.map(function (item) {
      return (
        '<div class="cart-line" data-line-qty="' + item.quantity + '">' +
          '<img class="cart-line__img" src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '">' +
          '<div>' +
            '<p class="cart-line__name">' + escapeHtml(item.product_title) + '</p>' +
            (item.variant_title ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
            '<p class="cart-line__price">' + formatMoney(item.final_line_price) + '</p>' +
            '<div class="cart-line__controls">' +
              '<button class="qty-btn" data-qty-change="-1" data-key="' + item.key + '">−</button>' +
              '<span class="qty-value">' + item.quantity + '</span>' +
              '<button class="qty-btn" data-qty-change="1" data-key="' + item.key + '">+</button>' +
              '<button class="cart-line__remove" data-line-remove data-key="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
    body.innerHTML = html;

    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    var threshold = parseFloat(drawer.getAttribute('data-free-shipping-threshold') || '50') * 100;
    var remainingEl = drawer.querySelector('[data-cart-remaining]');
    var barFill = drawer.querySelector('[data-cart-bar-fill]');
    var shippingBox = drawer.querySelector('[data-cart-shipping]');
    if (shippingBox && threshold > 0) {
      var remaining = Math.max(0, threshold - cart.total_price);
      var progress = Math.min(100, (cart.total_price / threshold) * 100);
      if (barFill) barFill.style.width = progress + '%';
      if (remaining > 0) {
        shippingBox.querySelector('[data-shipping-unlocked]').hidden = true;
        shippingBox.querySelector('[data-shipping-progress]').hidden = false;
        if (remainingEl) remainingEl.textContent = formatMoney(remaining);
      } else {
        shippingBox.querySelector('[data-shipping-unlocked]').hidden = false;
        shippingBox.querySelector('[data-shipping-progress]').hidden = true;
      }
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var variantId = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    addToCart(variantId, qty);
  });

  document.addEventListener('click', function (e) {
    var quickAdd = e.target.closest('[data-quick-add]');
    if (!quickAdd) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = quickAdd.getAttribute('data-quick-add');
    var originalHtml = quickAdd.innerHTML;
    addToCart(variantId, 1).then(function () {
      quickAdd.classList.add('is-added');
      quickAdd.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      setTimeout(function () {
        quickAdd.classList.remove('is-added');
        quickAdd.innerHTML = originalHtml;
      }, 1500);
    });
  });

  refreshDrawer();
}

function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}
function escapeHtml(str) {
  var div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

/* ---------- Email popup (session-based, matches original 6s delay) ---------- */
function initEmailPopup() {
  var overlay = document.querySelector('[data-email-popup]');
  if (!overlay) return;
  var STORAGE_KEY = 'mybutchery-popup-seen';

  var seen = false;
  try { seen = sessionStorage.getItem(STORAGE_KEY) === 'true'; } catch (e) {}

  if (!seen) {
    setTimeout(function () {
      overlay.classList.add('is-open');
    }, 6000);
  }

  function close() {
    overlay.classList.remove('is-open');
    try { sessionStorage.setItem(STORAGE_KEY, 'true'); } catch (e) {}
  }

  overlay.querySelectorAll('[data-email-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });

  var form = overlay.querySelector('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      overlay.querySelector('[data-popup-form]').hidden = true;
      overlay.querySelector('[data-popup-success]').hidden = false;
      setTimeout(close, 2500);
    });
  }
}

/* ---------- FAQ accordions ---------- */
function initFaqAccordions() {
  document.querySelectorAll('[data-faq-item]').forEach(function (item) {
    var btn = item.querySelector('.faq-item__q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      item.closest('[data-faq-list]').querySelectorAll('[data-faq-item]').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!isOpen) item.classList.add('is-open');
    });
  });
}

/* ---------- Horizontal product rails (Best Sellers) ---------- */
function initProductRails() {
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!track) return;
    function scrollBy(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.75, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  });
}

/* ---------- Product quantity controls ---------- */
function initProductGallery() {
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    stepper.querySelectorAll('[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-step'), 10);
        var value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = value;
        input.dispatchEvent(new Event('change'));
      });
    });
  });
}

/* ---------- Swipeable product image gallery (touch + thumbnail/dot sync) ---------- */
function initSwipeGallery() {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!track || slides.length === 0) return;

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    function setActive(index) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
      });
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-index'), 10));
      });
    });

    if (slides.length > 1) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var width = track.clientWidth || 1;
          var index = Math.round(track.scrollLeft / width);
          setActive(Math.max(0, Math.min(index, slides.length - 1)));
          ticking = false;
        });
      });
    }
  });
}

/* ---------- Sticky mobile add-to-cart bar ---------- */
function initStickyAddToCart() {
  var bar = document.querySelector('[data-sticky-atc]');
  var trigger = document.querySelector('.qty-add-row');
  var mainForm = document.querySelector('[data-product-form]');
  if (!bar || !trigger || !mainForm) return;

  var priceEl = bar.querySelector('[data-sticky-atc-price]');
  var addBtn = bar.querySelector('[data-sticky-atc-add]');
  var mainPriceEl = document.querySelector('[data-product-price]');

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var pastTrigger = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
        bar.classList.toggle('is-visible', pastTrigger);
      });
    }, { threshold: 0 });
    observer.observe(trigger);
  }

  if (mainPriceEl && priceEl) {
    var syncPrice = function () { priceEl.textContent = mainPriceEl.textContent; };
    syncPrice();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(syncPrice);
      mo.observe(mainPriceEl, { childList: true, characterData: true, subtree: true });
    }
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      if (mainForm.requestSubmit) mainForm.requestSubmit();
      else mainForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      addBtn.classList.add('is-added');
      setTimeout(function () { addBtn.classList.remove('is-added'); }, 1200);
    });
  }
}

/* ---------- Collection filter panel toggle ---------- */
function initFilterPanels() {
  document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
    var panel = document.querySelector(btn.getAttribute('data-filter-toggle'));
    if (!panel) return;
    btn.addEventListener('click', function () { panel.classList.toggle('is-open'); });
    var closeBtn = panel.querySelector('[data-filter-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { panel.classList.remove('is-open'); });
  });

  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
}

/* ---------- Scroll-triggered reveal animations (homepage storytelling) ---------- */
function initScrollReveal() {
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var groups = document.querySelectorAll('[data-reveal-stagger]');
  groups.forEach(function (group) {
    Array.from(group.children).forEach(function (child, i) {
      child.setAttribute('data-reveal', '');
      child.style.setProperty('--reveal-i', i);
    });
  });

  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  if (prefersReduced || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function (el) { observer.observe(el); });
}
